class VwHbsBransDTO {
    id?: number;
    bransgrupId?: number;
    bransGrupAdi?: string;
    kodu?: string;
    adi?: string;
    resmikodu?: string;
    resmiadi?: string;
    goruntuadi?: string;
    aktif?: string;
    ekleyenKullanici?: string;
    eklemeTarih?: Date;
    guncelleyenKullanici?: string;
    guncellemeTarihi?: Date;
    aktifBool?: boolean;
    kontrolsuregun?: number = 0;
}
export default VwHbsBransDTO;